// The Avenue School/the-avenue-school/client/src/pages/EventDetail.js
import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import axios from "axios";
import moment from "moment";
import { API_BASE } from "../lib/apiBase";
import { resolveAssetUrl } from "../lib/assetUrl"; // NEW: to render uploaded image
import "../styles/event-detail.css";

export default function EventDetail() {
  const { id } = useParams();
  const [event, setEvent] = useState(null);
  const [loading, setLoading] = useState(true);
  const [err, setErr] = useState(null);

  useEffect(() => {
    let alive = true;
    const fetchEvent = async () => {
      try {
        setLoading(true);
        setErr(null);
        const res = await axios.get(`${API_BASE}/events/${id}`, { withCredentials: true });
        if (!alive) return;
        setEvent(res?.data || null);
      } catch (e) {
        if (!alive) return;
        console.error("Error fetching event:", e);
        setErr("We couldn’t find that event.");
      } finally {
        if (alive) setLoading(false);
      }
    };
    fetchEvent();
    return () => { alive = false; };
  }, [id]);

  if (loading) {
    return (
      <main className="event-detail-wrap">
        <div className="event-detail-card" role="status" aria-live="polite">
          Loading event…
        </div>
      </main>
    );
  }

  if (err || !event) {
    return (
      <main className="event-detail-wrap">
        <div className="event-detail-card" role="alert">
          {err || "Event not found."}
        </div>
        <div className="event-detail-back">
          <Link to="/" className="event-detail-backlink">← Back to Home</Link>
        </div>
      </main>
    );
  }

  const date = event.date ? moment(event.date) : null;
  const day = date ? date.format("D") : "";
  const mon = date ? date.format("MMM") : "";

  // Choose the first uploaded image, if any
  const imageUrl = Array.isArray(event.images) && event.images.length > 0
    ? resolveAssetUrl(event.images[0])
    : null;

  return (
    <main className="event-detail-wrap">
      {/* Green header card */}
      <article className="event-detail-card">
        <header className="event-detail-header">
          <div className="event-detail-date" aria-hidden="true">
            <div className="event-detail-day">{day}</div>
            <div className="event-detail-mon">{mon}</div>
          </div>
          <div className="event-detail-heading">
            <h1 className="event-detail-title">{event.title || "(Untitled event)"}</h1>
            {date && (
              <time className="event-detail-when" dateTime={date.toISOString()}>
                {date.format("MMMM D, YYYY")}
              </time>
            )}
          </div>
        </header>
      </article>

      {/* NEW: image block (white bg, sits between header and description) */}
      {imageUrl && (
        <figure className="event-detail-media">
          <img
            className="event-detail-img"
            src={imageUrl}
            alt={event.title ? `${event.title} — event image` : "Event image"} // TODO: if server provides alt, use it
            loading="lazy"
          />
          {/* Optional caption if you later add one to the API */}
          {/* {event.imageCaption && <figcaption className="event-detail-caption">{event.imageCaption}</figcaption>} */}
        </figure>
      )}

      {/* Separate white section for description */}
      {event.description && (
        <section className="event-detail-desc-section">
          <p className="event-detail-desc" style={{ whiteSpace: "pre-wrap" }}>
            {event.description}
          </p>
        </section>
      )}

      <div className="event-detail-back">
        <Link to="/" className="event-detail-backlink">← Back to Home</Link>
      </div>
    </main>
  );
}
